export default __webpack_public_path__ + "static/media/portrait.0d34c763.glb";